import {ValueObject} from '@s-ui/domain'

export class FaqValueObject extends ValueObject {
  /**
   * @param {Object} params
   * @param {String} params.question
   * @param {String} params.answer
   * */
}
